<template>
	<div class="main" style="width:1440px;margin: 0 auto; ">
		<div class="banner_box">
			<img src="/banner02.jpg" alt="" width="1440px" height="300px">
		</div>
		<div class="container"  v-if='!isShow'>
			<template v-for="(item,index) in customerCaseList">
				<div class="box">
					<img v-if="item.img" :src="imgurl+ item.img" alt="" srcset="" width="180" height="80">
					<div  v-if="!item.img" style="height: 80px;"></div>
					<div>{{item.name}}</div>
					<!-- <div>XXXX类XX平台</div> -->
					<div @click='clickFun(item)'>案例详情</div>
				</div>
			</template>
		</div>
		<div v-if='isShow' style="margin: 30px;">
			<!-- <div style="padding: 10px; border: 1px solid #3894ff;">返回</div> -->
			<button style="padding: 8px 15px; border: 1px solid #3894ff;background-color: #3894ff; color:#fff;border-radius: 5px;" @click="isShow=!isShow">返回</button>
			<div class="text">{{title}}</div>
			<p v-html="container"></p>
		</div>
		

	</div>
</template>

<script>
	
	import Vue from 'vue';
	import {
		imgurl,getAction,putformAction
	} from "@/api/manage";
		
		
	export default {
		name: 'HelloWorld3',
		props: {
			msg: String
		},
		data() {
			return {
				imgurl: imgurl,
				customerCaseList:[],
				isShow:false,
				container:"",
				title:"",
			}
		},
		mounted(e) {
			this.getCustomerCase()
		},
		watch: {
			$route: {
				deep: true,
				immediate: true,
				handler(val) {
					this.updatetype();
				}
			}
		},
		
		
		methods: {
			clickFun(item) {
				this.isShow = true
				this.container = item.description
				this.title = item.name
			},
			getCustomerCase(){
				let that = this;
				let param = {
					pageNo:1,
					pageSize:8,
				};
				getAction("viwo/customerCase/list", param).then(res => {
					if (res.success && res.result) {
						that.customerCaseList = res.result.records;
						console.log("公司信息res===",res)
					}
				})
			},

		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
	.main {
		width:1440px;
		margin: 0 auto; 
		// min-height: 1426px;
	}
	a {
		text-decoration: none;
	}

	.container {
		width: 1200px;
		margin: 110px auto 0;
		padding: 0 100px;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		.box {
			width: 260px;
			height: 310px;
			line-height: 20px;
			background-color: rgba(255,255,255,1);
			color: rgba(16,16,16,1);
			font-size: 14px;
			text-align: center;
			font-family: -regular;
			border: 1px solid rgba(174,174,174,1);
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			margin-bottom: 50px;
			
			// margin: 30px;
			div:nth-child(2){
				// width: 168px;
				height: 36px;
				line-height: 36px;
				font-size: 18px;
				text-align: left;
				font-family: SourceHanSansSC-regular;
				margin-top: 15px;
			}
			div:nth-child(3){
				line-height: 27px;
				color: rgb(174,174,174);
				font-size: 14px;
				text-align: center;
				font-family: SourceHanSansSC-regular;
			}
			div:last-child{
				margin-top: 48px;
				width: 130px;
				height: 35px;
				line-height: 35px;
				border-radius: 5px;
				background-color: rgba(255,255,255,1);
				color: rgba(56, 148, 255, 1);
				font-size: 14px;
				text-align: center;
				font-family: -regular;
				border: 1px solid rgba(56,148,255,1);
			}
		}
	}
	.text {
		text-align: center;
		color: #3894ff;
		font-size: 32px;
	}
	
</style>